export enum FeatureFlags {
  COMPARE_VIEW = "designControlsComparisonView",
  LINK_RESOURCE_LIBRARY_PRODUCT = "dc-link-resource-library-product",
  MAJOR_MINOR_VERSION_UI = "design-element-major-minor-version-ui",
  SEARCH_READ_NEW_INDEX = "dc-elements-search-read-new-index",
  VERSION_TRACELINK_UI = "design-element-version-tracelink-ui",
}
